import LocalStorage from '../LocalStorage';

const key = 'referral_uuid';

const LocalStorageReferral_uuid = {
    has: (): boolean => {
        return !!LocalStorage.get(key);
    },

    set: (referral_uuid: string): void => {
        LocalStorage.set(key, referral_uuid);
    },

    get: (): string | null => {
        return LocalStorage.get(key);
    },

    remove: (): void => {
        LocalStorage.remove(key);
    },
};

export default LocalStorageReferral_uuid;
